import React from 'react'
import loadable from '@loadable/component'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import PreloaderSVG from '@krea/common/images/svg/preloader.svg'

import styles from './Preloader.module.scss'

const SVG = loadable(() => import('react-inlinesvg'))

const Preloader = ({ className, size }) => {
	return (
		<div className={classnames('d-flex justify-content-center align-items-center', className)}>
			<div className={classnames(styles.icon, styles[size], 'position-relative')}>
				<SVG className="position-absolute w-100 h-auto" src={PreloaderSVG} />
			</div>
		</div>
	)
}

Preloader.propTypes = {
	size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl'])
}

Preloader.defaultProps = {
	size: 'md'
}

export default Preloader
